<template>
  <div class="team-selection">
    <div class="team-arena-title">
      <a-icon type="team" /> 参战团队
      <span class="team-count">{{ displayTeams.length }}个团队</span>
    </div>
    <div class="team-grid">
      <div
        v-for="(team, index) in displayTeams"
        :key="team.id"
        :class="[
          'team-card',
          {
            current: team.result === 1,
            waiting: team.result === 2,
            excluded: team.result === 4
          }
        ]"
        @click="$emit('team-action', team, index)"
      >
        <div class="team-avatar">
          {{ team.name.charAt(0) }}
        </div>
        <div class="team-info">
          <div class="team-name">{{ team.name }}</div>
          <div class="team-label">
            <template v-if="team.result === null">
              <span v-if="team.ready === true" class="team-ready">已准备</span>
              <span v-else class="team-not-ready">未准备</span>
            </template>
            <template v-else>
              <span v-if="team.result === 1">当前挑战者</span>
              <span v-else-if="team.result === 2">第{{ index + 1 }}位</span>
              <span v-else-if="team.result === 4">已出局</span>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeamSelection',
  props: {
    displayTeams: {
      type: Array,
      default: () => []
    },
    auctionStarted: {
      type: Boolean,
      default: false
    }
  },
  emits: ['team-action']
};
</script>

<style lang="less" scoped>
.team-selection {
  margin-bottom: 2rem;

  .team-arena-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #1d2129;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;

    .team-count {
      font-size: 0.8125rem;
      color: #86909c;
      background: #f2f3f5;
      padding: 0.2rem 0.6rem;
      border-radius: 999px;
    }
  }

  .team-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(115px, 1fr));
    gap: 1rem;
  }

  .team-card {
    background: linear-gradient(145deg, #f7f8fa, #ffffff);
    color: #1d2129;
    border: 1px solid rgba(0, 0, 0, 0.03);
    border-radius: 8px;
    padding: 1rem;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 2px;
      background: transparent;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    }

    &:hover::before {
      background: linear-gradient(90deg, #165dff, #722ed1);
    }

    &.current {
      background: linear-gradient(145deg, #fff5f5, #ffffff);
      border-color: rgba(245, 63, 63, 0.08);
    }

    &.current::before {
      background: linear-gradient(90deg, #f53f3f, #f76560);
    }

    &.waiting {
      background: linear-gradient(145deg, #f4f3ff, #ffffff);
      border-color: rgba(114, 46, 209, 0.08);
    }

    &.excluded {
      background: #f7f8fa;
      color: #86909c;
      cursor: not-allowed;
      border-color: #f2f3f5;
      opacity: 0.8;

      .team-info {
        .team-name {
          color: #86909c;
          font-weight: 500;
        }
      }

      .team-avatar {
        filter: grayscale(50%);
        opacity: 0.7;
      }
    }

    .team-avatar {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      background: linear-gradient(135deg, #4080ff, #165dff);
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.25rem;
      font-weight: 700;
      margin-bottom: 0.25rem;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 3px 10px rgba(22, 93, 255, 0.15);
    }

    &:hover .team-avatar {
      transform: scale(1.05);
      box-shadow: 0 5px 14px rgba(22, 93, 255, 0.25);
    }

    &.current .team-avatar {
      background: linear-gradient(135deg, #f53f3f, #f76560);
      box-shadow: 0 3px 10px rgba(245, 63, 63, 0.15);
    }

    &.current:hover .team-avatar {
      box-shadow: 0 5px 14px rgba(245, 63, 63, 0.25);
    }

    .team-info {
      .team-name {
        font-size: 0.9375rem;
        font-weight: 600;
        margin-bottom: 0.5rem;
        color: #1d2129;
      }

      .team-label {
        font-size: 0.75rem;
        color: #86909c;
        padding: 0.1rem 0.5rem;
        border-radius: 3px;
        background: rgba(0, 0, 0, 0.03);
      }

      .team-ready {
        color: #165dff;
      }
      .team-not-ready {
        color: #86909c;
      }
    }
  }
}

@media (max-width: 768px) {
  .team-selection {
    .team-grid {
      grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
      gap: 0.75rem;
    }
  }
}
</style>
